export default __webpack_public_path__ + "img/img_ed-58ed4c7fcdc826534b555d8dfebb5d93.jpg";